import React, { useState, useEffect } from "react";
import {
    Box,
    Typography,
    Divider,
    TextField,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Button,
    Select,
    MenuItem
} from "@mui/material";

import { BiShow } from "react-icons/bi";
import { useGetAllUsersQuery } from "../../../redux/slices/admin/workers/allUserSlince.js";
import { useOutletContext } from "react-router-dom";
import { Pagination } from "@mui/material";
import "../../../styles/admin.css/workers-css/employee-logs.css";

export default function EmployeeLogs() {
    const { sidebarOpen } = useOutletContext();



    const { data: employees = [], isLoading, refetch } = useGetAllUsersQuery(undefined, {
        refetchOnMountOrArgChange: true,
    });

    console.log('Employees data:', employees);
    console.log('Employee logs:', employees.map(emp => ({
        email: emp.personalMail,
        logs: emp.userLogDtos,
        logsCount: emp.userLogDtos?.length || 0
    })));



    const [search, setSearch] = useState("");
    const [openRow, setOpenRow] = useState(null);
    const [selectedDate, setSelectedDate] = useState("all");
    const [logPage, setLogPage] = useState(1);
    const logsPerPage = 50;

    const filteredEmployees = employees.filter(emp =>
        (`${emp.name} ${emp.surname}`).toLowerCase().includes(search.toLowerCase()) ||
        emp.personalMail?.toLowerCase().includes(search.toLowerCase()) ||
        emp.phoneNumber?.includes(search)
    );




    const handleRecordsClick = (emp) => {
        setOpenRow(openRow === emp.id ? null : emp.id);
        setSelectedDate("all");
    };

    useEffect(() => {
        setLogPage(1);
    }, [openRow, selectedDate]);

    return (
        <Box className={`logs-container ${sidebarOpen ? "sidebar-open" : ""}`}>

            <Box className="logs-header">
                <Box className="logs-title">
                    <Typography style={{ color: "#545A61" }}>
                        İşçilərin Qeydləri
                    </Typography>
                    <Divider className="logs-divider" />
                </Box>

                <TextField
                    size="small"
                    placeholder="Axtar..."
                    className="logs-search"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                />
            </Box>

            <TableContainer component={Paper} className="logs-table">
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell><strong>#No</strong></TableCell>
                            <TableCell><strong>Tam Ad</strong></TableCell>
                            <TableCell><strong>Panel e-poçt</strong></TableCell>
                            <TableCell><strong>Əlaqə nömrəsi</strong></TableCell>
                            <TableCell><strong>Yaradılma tarixi</strong></TableCell>
                            <TableCell><strong>Seçimlər</strong></TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {isLoading ? (
                            <TableRow>
                                <TableCell colSpan={6} align="center">
                                    Yüklənir...
                                </TableCell>
                            </TableRow>
                        ) : filteredEmployees.length === 0 ? (
                            <TableRow>
                                <TableCell colSpan={6} align="center">
                                    Məlumat tapılmadı
                                </TableCell>
                            </TableRow>
                        ) : (
                            filteredEmployees.map((emp, index) => (
                                <React.Fragment key={emp.id}>
                                    <TableRow>
                                        <TableCell>
                                            {"#" + String(emp.serialNo || emp.id).padStart(4, "0")}
                                        </TableCell>
                                        <TableCell>{emp.name} {emp.surname}</TableCell>
                                        <TableCell>{emp.personalMail}</TableCell>
                                        <TableCell><strong>+994 {emp.phoneNumber}</strong></TableCell>
                                        <TableCell>
                                            {emp.createdAt
                                                ? new Date(emp.createdAt).toLocaleString()
                                                : "-"}
                                        </TableCell>
                                        <TableCell className="manage-wrapper">
                                            <Button
                                                size="small"
                                                variant="contained"
                                                className="logs-btn"
                                                onClick={() => handleRecordsClick(emp)}
                                            >
                                                <BiShow style={{ width: "24px", height: "24px" }} />
                                            </Button>
                                        </TableCell>
                                    </TableRow>

                                    {openRow === emp.id && (
                                        <TableRow>
                                            <TableCell colSpan={6} className="logs-expanded-cell">
                                                <Box className="logs-expanded-wrapper">

                                                    <Box className="logs-inline-header">
                                                        <Box className="logs-inline-left">
                                                            <Typography className="logs-inline-title">
                                                                İcra tarixi
                                                            </Typography>
                                                            <Typography className="logs-inline-title">
                                                                İcra olunan
                                                            </Typography>
                                                        </Box>
                                                        <Select
                                                            value={selectedDate}
                                                            onChange={(e) => setSelectedDate(e.target.value)}
                                                            size="small"
                                                            displayEmpty
                                                            MenuProps={{
                                                                anchorOrigin: {
                                                                    vertical: "bottom",
                                                                    horizontal: "left",
                                                                },
                                                                transformOrigin: {
                                                                    vertical: "top",
                                                                    horizontal: "left",
                                                                },
                                                                PaperProps: {
                                                                    style: {
                                                                        maxHeight: 300,
                                                                        marginTop: "4px",
                                                                        minWidth: "150px",
                                                                    },
                                                                },
                                                            }}
                                                        >
                                                            <MenuItem value="all">Bütün qeydlər</MenuItem>


                                                            {Array.from(new Set((emp.userLogDtos || []).map(l => l.createdAt?.split('T')[0])))
                                                                .filter(Boolean)
                                                                .sort((a, b) => new Date(b) - new Date(a))
                                                                .map(date => (
                                                                    <MenuItem key={date} value={date}>{date}</MenuItem>
                                                                ))
                                                            }
                                                        </Select>

                                                    </Box>

                                                    <Divider className="logs-divider-two" />

                                                    <Box className="logs-filtered-data">
                                                        {(() => {
                                                            const rawLogs = emp.userLogDtos || [];


                                                            let filteredLogs = [];


                                                            if (!selectedDate || selectedDate === "all" || selectedDate === "") {
                                                                filteredLogs = [...rawLogs];
                                                            } else {

                                                                filteredLogs = rawLogs.filter(log =>
                                                                    log.createdAt && log.createdAt.startsWith(selectedDate)
                                                                );
                                                            }


                                                            filteredLogs.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));


                                                            const totalLogs = filteredLogs.length;
                                                            const totalPages = Math.ceil(totalLogs / logsPerPage);
                                                            const startIndex = (logPage - 1) * logsPerPage;
                                                            const paginatedLogs = filteredLogs.slice(startIndex, startIndex + logsPerPage);

                                                            if (totalLogs === 0) {
                                                                return <Typography sx={{ p: 2, color: 'gray', textAlign: 'center' }}>Qeyd tapılmadı.</Typography>;
                                                            }

                                                            return (
                                                                <Box>
                                                                    <Box className="logs-list">
                                                                        {paginatedLogs.map((log, i) => (
                                                                            <Box key={i} className="logs-entry" sx={{ mb: 1, p: 1, borderBottom: '1px solid #eee' }}>
                                                                                <Typography className="logs-entry-date" variant="caption" display="block" color="textSecondary">
                                                                                    {log.createdAt ? new Date(log.createdAt).toLocaleString('az-AZ') : "-"}
                                                                                </Typography>
                                                                                <Typography className="logs-entry-message">
                                                                                    {log.action}
                                                                                </Typography>
                                                                            </Box>
                                                                        ))}
                                                                    </Box>


                                                                    {totalLogs > logsPerPage && (
                                                                        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2, pb: 1 }}>
                                                                            <Pagination
                                                                                count={totalPages}
                                                                                page={logPage}
                                                                                onChange={(e, value) => setLogPage(value)}
                                                                                size="small"
                                                                                color="primary"
                                                                                siblingCount={0}
                                                                            />
                                                                        </Box>
                                                                    )}
                                                                </Box>
                                                            );
                                                        })()}
                                                    </Box>
                                                </Box>
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </React.Fragment>
                            ))
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
}
